<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
  import { onBeforeMount } from 'vue'
  import { useGlobalStore } from '@/stores/global.js'
  import { useUserStore } from '@/stores/user.js'

  const globalStore = useGlobalStore()
  const userStore = useUserStore()

  onBeforeMount(() => {
    globalStore.showPageLoader = false

    const existingFeedbucketScript = document.querySelector('script[data-feedbucket="TeTlLIPQNaiJa0Q9iTq6"]')

    if (!existingFeedbucketScript) {
      const script = document.createElement('script')
      script.defer = true
      script.src = 'https://cdn.feedbucket.app/assets/feedbucket.js'
      script.dataset.feedbucket = 'TeTlLIPQNaiJa0Q9iTq6'
      document.head.appendChild(script)
    }

    if (userStore.hasToken && !userStore.user.official) {
      // Call Datastore to load initial data
    }
  })
</script>
